import { montserratNormal, montserratSemibold } from "@/assets/fonts/montserrat";

export default function Tooltip({ message, children }) {
    return (
        <span className="group relative drop-shadow-xl">
            <span className={`${montserratSemibold.className} text-[12px] pointer-events-none rounded-lg absolute -top-10 -left-10 -translate-x-1/2 whitespace-nowrap bg-base-white px-2 py-1 text-base-black opacity-0 transition group-hover:opacity-100`}>
                {message}
            </span>
            <div className="opacity-0 -z-10 absolute right-8 -top-4 transition group-hover:opacity-100">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="9" viewBox="0 0 16 9" fill="none">
                    <path d="M14.0711 0.485289C14.962 0.485289 15.4081 1.56243 14.7782 2.1924L8.70711 8.26347C8.31658 8.654 7.68342 8.654 7.29289 8.26347L1.22183 2.1924C0.591867 1.56243 1.03803 0.485289 1.92894 0.485289L14.0711 0.485289Z" stroke="none" fill="white"/>
                </svg>
            </div>
            {children}
        </span>
    );
  }
  